import { AppBar, Checkbox, DialogActions, DialogContent, FormControl, FormControlLabel, MenuItem, TextField, Toolbar, Typography } from "@material-ui/core";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React, { useEffect, useState } from "react";
import XAPPButton from "../Button/XAPPButton";
import XAPPDialog from "../Dialog/XAPPDialog";

const md = new MobileDetect(window.navigator.userAgent);

const CustomFieldDialog = (props) => {

  const { onClose, open, save, TIPOS_CAMPO, grupos } = props;
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (!_.isNull(open) && _.isNull(form)) {
      setForm(open);
    }
    if (_.isNull(open) && !_.isNull(form)) {
      setForm(null);
    }
  }, [open]);

  function canBeSubmitted() {
    return true;
  }

  function getTipoProp() {
    switch (form.tipo) {
      case "grupo": return "grupos";
      case "campo": return "campos";
    }
  }

  function onChange(ev) {
    let tmp = _.set({ ...form }, ev.target.name, event.target.type === "checkbox" ? ev.target.checked : ev.target.value);
    if (form.index === 0 && ev.target.name === "label") {
      tmp.id = ev.target.value.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s/g, "-");
    }
    if (ev.target.name === "index") {
      tmp.index = Number(ev.target.value) > 0 ? Number(ev.target.value) : Number(form.index);
    }
    if (ev.target.name === "type" && ev.target.value === "select") {
      tmp.items = [{ "index": new Date().getTime(), "id": "", "label": "" }];
    }
    setForm(tmp);
  }

  function addSubItem() {
    let items = [];
    if (_.isArray(form.items)) {
      items = items.concat(form.items);
    }
    items.push({ "index": new Date().getTime(), "id": "", "label": "" });
    setForm(_.set({ ...form }, "items", items));
  }

  function onChangeSubItem(ev, index) {
    let items = [].concat(form.items);
    let pos = _.findIndex(items, { "index": index });
    if (ev.target.name === "label") {
      items[pos] = _.set({ ...items[pos] }, "id", ev.target.value.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s/g, "-"));
    }
    items[pos] = _.set({ ...items[pos] }, ev.target.name, ev.target.value);
    setForm(_.set({ ...form }, "items", items));
  }

  function removeSubItem(ev, index) {
    let items = [].concat(form.items);
    items.splice(_.findIndex(items, { "index": index }), 1);
    setForm(_.set({ ...form }, "items", items));
  }

  return (
    <XAPPDialog
      id="CustomFields"
      open={!_.isNull(form)}
      onClose={() => onClose()}
      fullWidth
      fullScreen={md.mobile() !== null}
      maxWidth="sm"
    >
      <AppBar position="static" elevation={1}>
        <Toolbar className="flex w-full min-h-0">
          <Typography variant="subtitle1 text-white">
            {`Editar ${form?.tipo}`}
          </Typography>
          <div className="flex-1" />
          <XAPPButton
            type="icon"
            icon={"close"}
            iconProps={"text-20 text-white"}
            className="p-6"
            onClick={() => onClose()}
          />
        </Toolbar>
      </AppBar>
      <DialogContent classes={{ root: "p-24" }}>
        {form?.tipo === "grupo" &&
          <React.Fragment>
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-full"
                label={"Nome"}
                key={"name"}
                name={"name"}
                value={form.name}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>

            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <FormControl className={""}>
                <FormControlLabel
                  className={"mx-0"}
                  control={
                    <Checkbox
                      className="p-6 mr-8"
                      name={"defaultOpen"}
                      type='checkbox'
                      checked={form.defaultOpen}
                      onChange={onChange}
                    />
                  }
                  label={"Aberto (padrão)"}
                />
              </FormControl>
            </div>
          </React.Fragment>
        }
        {form?.tipo === "campo" &&
          <React.Fragment>
            <TextField
              className="hidden"
              name={"id"}
              value={form.id}
            />
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-1/3"
                label={"Index"}
                key={"index"}
                name={"index"}
                value={form.index}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                className="w-full"
                label={"Nome"}
                key={"label"}
                name={"label"}
                value={form.label}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-full"
                label={"Grupo"}
                key={"grupo"}
                name={"grupo"}
                value={form.grupo}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                select
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {grupos.map(item => (
                  <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                ))}
              </TextField>
            </div>
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-full"
                label={"Tipo"}
                key={"type"}
                name={"type"}
                value={form.type}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                select
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {TIPOS_CAMPO.map(item => (
                  <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
                ))}
              </TextField>
            </div>
            {form.type === "select" &&
              <div className="flex flex-col gap-8">
                <div className="flex w-full items-center">
                  <Typography className="inline font-medium" color="primary" paragraph={false}>{"Opções"}</Typography>
                  <div className="flex-1" />
                  <XAPPButton
                    tooltip={{ "title": "Adicionar item", "placement": "top" }}
                    type="Icon"
                    color="primary"
                    className=""
                    onClick={addSubItem}
                    icon={"add"}
                  />
                </div>
                {form?.items.map(item => (
                  <div className="flex gap-8" key={item.index}>
                    <TextField
                      className="hidden"
                      name={"id"}
                      value={item.id}
                    />
                    <TextField
                      className="w-full"
                      label={"Valor"}
                      key={"label"}
                      name={"label"}
                      value={item.label}
                      onChange={ev => onChangeSubItem(ev, item.index)}
                      required={true}
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <XAPPButton
                      tooltip={{ "title": "Remover item", "placement": "top" }}
                      type="Icon"
                      color="primary"
                      className=""
                      onClick={removeSubItem}
                      icon={"delete"}
                    />
                  </div>
                ))}
              </div>
            }
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <FormControl className={""}>
                <FormControlLabel
                  className={"mx-0"}
                  control={
                    <Checkbox
                      className="p-6 mr-8"
                      name={"required"}
                      type='checkbox'
                      checked={form.required}
                      onChange={onChange}
                    />
                  }
                  label={"Obrigatório"}
                />
                <FormControlLabel
                  className={"mx-0"}
                  control={
                    <Checkbox
                      className="p-6 mr-8"
                      name={"locked"}
                      type='checkbox'
                      checked={form.locked}
                      onChange={onChange}
                    />
                  }
                  label={"Bloqueado"}
                />
              </FormControl>
            </div>
          </React.Fragment>
        }
      </DialogContent>
      <AppBar position="static" elevation={3} color="textSecondary">
        <Toolbar className="flex w-full justify-end min-h-0">
          <DialogActions>
            <XAPPButton
              type="Button"
              className="bg-green hover:bg-green text-white mr-8"
              variant="contained"
              color="primary"
              onClick={() => save(getTipoProp(), { ...form, "tipo": undefined })}
              disabled={!canBeSubmitted()}
              iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
              icon={"save"}
              label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
            />
          </DialogActions>
        </Toolbar>
      </AppBar>
    </XAPPDialog>
  );
};

export default CustomFieldDialog;
